import './style.css';
import axios from 'axios';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import localStorage from '../../../../utils/localStorage';
import StyledTable from "../../../../commons/styles/table";
import { API_DASHBOARD } from '../../../../commons/api';
import {
  Row,
  Col,
  Form,
  Slider,
  Button,
  InputNumber,
  DatePicker,
  message,
  Radio,
} from 'antd';

const SmartMotorControl = (props) => {
  //const [visible, setVisible] = useState(false);
  //const [parameterList, setParameterList] = useState([]);
  //const [minValue, setMinValue] = useState(0);
  const minValue = 0;
  const maxValue = 50;
  //const [maxValue, setMaxValue] = useState(50);
  //const [formType, setFormType] = useState('');
  const [mode, setMode] = useState('');
  const [userProfile, setUserProfile] = useState(props.userProfile);
  //const [Time, setTime] = useState(moment().format('HH:mm'));
  const [parameterValue, setParameterValue] = useState(undefined);

  useEffect(() => {
    try {
      (props.match.params.name);
    } catch (error) {
      console.log(error);
    }
  }, [props.match.params.name]);

  useEffect(() => {
    if (props.userProfile !== userProfile) {
      setUserProfile(props.userProfile);
    }
  }, [props.userProfile]);

  const handleSubmit = () => {
    let payload = {};

    if (mode === '' || parameterValue === undefined) {
      message.error('Please Provide SetPoints');
    } else {
      payload = {
        motorSpeed: parameterValue,
        status: mode
      };
      formSubmission(payload);
    }
  };

  const formSubmission = (payload) => {
    const accessToken = localStorage.get('accessToken');
    const formSubmissionObject = {
      method: 'POST',
      url: `${API_DASHBOARD.VibratingMotorForm}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      data: payload
    };
    
    axios(formSubmissionObject)
      .then((response) => {
        message.success('Submitted Successfully');
        return response;
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const columns = [
    {
      title: 'SI.No',
      dataIndex: 'sno',
      key: 'sno'
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status'
    },
    {
      title: 'Frequency',
      dataIndex: 'frequency',
      key: 'frequency'
    },
    {
      title: 'Submitted Timestamp',
      dataIndex: 'timestamp',
      key: 'timestamp'
    },
    {
      title: 'User Name',
      dataIndex: 'userName',
      key: 'userName'
    }
  ];

  return (
    <div>
      <Row style={{ background: 'grey', padding: '50px' }}>
        <Col span={8}>
          <Form>
            <div className="mode3">
              <Row>
                <Col offset={6} span={8}>
                  <Radio.Group
                    onChange={(e) => setMode(e.target.value)}
                    buttonStyle="solid"
                  >
                    <Radio.Button value="start">START</Radio.Button>
                    <Radio.Button value="stop">STOP</Radio.Button>
                  </Radio.Group>
                </Col>
              </Row>

              <Row style={{ marginTop: '20px' }}>
                <Col offset={4} span={10}>
                  <h4 style={{  fontWeight: 'bold', color: '#000' }}>
                    Select Range
                  </h4>
                  <div className="sliderBackground">
                    <Slider
                      disabled={mode === 'start' ? false : true}
                      min={minValue}
                      max={maxValue}
                      value={parameterValue}
                      onChange={(value) => setParameterValue(value)}
                      tipFormatter={(value) => `${value}`}
                    />
                  </div>
                </Col>
                <Col span={2}>
                  <InputNumber
                    min={minValue}
                    max={maxValue}
                    style={{
                      width: '60px',
                      height: '50px',
                      marginTop: '35px',
                      marginLeft: '5px'
                    }}
                    value={mode === 'stop' ? 0 : parameterValue}
                    onChange={(value) => setParameterValue(value)}
                  />
                </Col>
              </Row>
              <Button
                style={{ marginLeft: '45%', marginTop: '60px' }}
                type="primary"
                shape="round"
                
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          </Form>
        </Col>

        <Col offset={4} span={8}>
          <DatePicker style={{ marginBottom: '10px', float: 'right' }} />
          <StyledTable size="small" columns={columns} />
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.LayoutReducer.loggedInProfile
});

export default connect(mapStateToProps)(SmartMotorControl);
